import { PriorityItemDto } from '../../../api';
import Popup from '../../Popup';
import ReassignPriorityForm from '../../../pages/admin/ReassignPriorityForm';
import PriorityQueries from '../../../pages/admin/PriorityQueries';

interface IReassignPrioritiesPopupProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  onSuccess?: () => void;
  priority: PriorityItemDto;
  newID?: number;
}

function ReassignPriorityPopup(props: IReassignPrioritiesPopupProps) {
  const { isOpen, setIsOpen, priority, onSuccess, newID } = props;
  const { mutateCreatePriority, mutateUpdatePriority } = PriorityQueries();
  return (
    <Popup openPopup={isOpen} setOpenPopup={setIsOpen} title="Move/Copy Priority">
      <ReassignPriorityForm
        onCancel={() => setIsOpen(false)}
        onSubmit={(values, operation) => {
          if (operation === 'Move') {
            mutateUpdatePriority(values, {
              onSuccess: onSuccess,
            });
          } else {
            mutateCreatePriority(values, {
              onSuccess: onSuccess,
            });
          }
        }}
        priority={priority!}
        newID={newID}
      />
    </Popup>
  );
}

export default ReassignPriorityPopup;
